import React from 'react';
import Icon from '../../../components/AppIcon';

import Button from '../../../components/ui/Button';

const AccountStatusCard = ({ platform, connection, onConnect, onDisconnect }) => {
  const getPlatformIcon = (platform) => {
    switch (platform) {
      case 'spotify':
        return 'Music';
      case 'youtube':
        return 'Play';
      default:
        return 'Link';
    }
  };

  const getPlatformColor = (platform) => {
    switch (platform) {
      case 'spotify':
        return 'text-success';
      case 'youtube':
        return 'text-error';
      default:
        return 'text-primary';
    }
  };

  const formatLastSync = (date) => {
    if (!date) return 'Never';
    
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    return `${days}d ago`;
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-4 lg:p-6 shadow-elevation-1">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${
            connection.connected ? 'bg-success/10' : 'bg-surface-secondary'
          }`}>
            <Icon 
              name={getPlatformIcon(platform)} 
              size={24} 
              className={connection.connected ? getPlatformColor(platform) : 'text-text-muted'}
            />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary capitalize">
              {platform}
            </h3>
            <div className="flex items-center space-x-2">
              <div className={`w-2 h-2 rounded-full ${
                connection.connected ? 'bg-success' : 'bg-error'
              }`}></div>
              <span className={`text-sm ${
                connection.connected ? 'text-success' : 'text-error'
              }`}>
                {connection.connected ? 'Connected' : 'Disconnected'}
              </span>
            </div>
          </div>
        </div>

        {connection.connected && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDisconnect(platform)}
            className="text-error hover:text-error hover:bg-error/10"
          >
            Disconnect
          </Button>
        )}
      </div>

      {connection.connected ? (
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center overflow-hidden">
              {
                connection?.picture ? (
                  <img src={connection?.picture} alt={connection?.name} className='' />
                ) : (
                  <Icon name="User" size={20} className="text-primary-foreground" />
                )
              }
            </div>
            <div>
              <p className="text-sm font-medium text-text-primary">
                @{connection.username}
              </p>
              <p className="text-xs text-text-secondary">
                {connection.playlistCount} playlists
              </p>
            </div>
          </div>
          
          <div className="flex items-center justify-between text-sm">
            <span className="text-text-secondary">Last sync:</span>
            <span className="text-text-primary font-medium">
              {formatLastSync(connection.lastSync)}
            </span>
          </div>
        </div>
      ) : (
        <div className="text-center py-4">
          <p className="text-text-muted text-sm mb-4">
            Connect your {platform} account to start syncing playlists 
          </p>
          <Button
            variant="primary"
            onClick={() => onConnect(platform)}
            iconName="Link"
            iconSize={16}
          >
            Connect {platform.charAt(0).toUpperCase() + platform.slice(1)}
          </Button>
        </div>
      )}
    </div>
  );
};

export default AccountStatusCard;